export default __webpack_public_path__ + "static/media/Milk2Icecream_08.62d3e2ca.png";